/* eslint-disable no-unused-vars */

import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import BookMarkModal from '@components/modal/variants/bookmark-modal';
import InputField from '@components/input-field/input-field.component';
import Checkbox from '@components/checkbox/checkbox.component';

import { getAppDispatch } from '@utilities/dispatch.util';
import { bookmarksActions } from '@redux/slices/bookmarks';
import { useToastContext } from 'context/toaster.context';
import BookmarkService from '@services/bookmarks.service';

import style from './style.module.scss';

const SiteBookmark = ({
  open,
  setOpen,
  placeholder = 'Flux capacitor repairs',
  filters = {},
  selectedSort = {},
  type = 'Sites',
  siteId = null,
  parentSiteId = null,
  keyName = null,
  tab = null,
  filterType,
  editMode,
  bookmarkPrefillName,
  onDelete,
  isBookmarkAtAGlance = null
}) => {
  const dispatch = getAppDispatch();
  const navigate = useNavigate();
  const [bookmarkName, setBookmarkName] = useState(editMode ? bookmarkPrefillName : '');
  const [pinToGlance, setPinToGlance] = useState(true);
  const userId = useSelector((state) => state.auth.userId) || '';
  const location = useLocation();

  useEffect(() => {
    if (isBookmarkAtAGlance) {
      setPinToGlance(isBookmarkAtAGlance === 'true' ? true : false);
    }
  }, [isBookmarkAtAGlance]);

  const { showMapView = false, selectedSiteIdForMapView } =
    useSelector((state) => state.siteMap) || {};

  const { ToasterUtil } = useToastContext();

  const onSubmit = async () => {
    const sort = !_.isEmpty(selectedSort)
      ? _.isArray
        ? { [selectedSort[0] === '# TASKS' ? 'Tasks' : selectedSort[0]]: true }
        : selectedSort
      : {};

    const filtersString = {
      filters: {
        ...filters,
        taskType: {
          value:
            filters?.taskType?.value?.length > 0
              ? filters?.taskType?.value
              : filterType === 'inspection' || filterType === 'Inspection'
              ? ['Inspections']
              : filterType === 'workOrder' || filterType === 'Work Order'
              ? ['Work orders']
              : filterType === 'workRequest'
              ? ['Work requests']
              : filterType === 'hseEvents'
              ? ['HSE event']
              : filterType === 'Check' || filterType === 'check'
              ? ['Check']
              : filters?.taskType?.value || []
        }
      },
      sort,
      siteId
    };

    const siteBookmarkData = {
      userId,
      name: bookmarkName,
      type,
      atAGlance: pinToGlance,
      filters: JSON.stringify(filtersString),
      listing: location?.pathname || '/',
      siteId,
      parentSiteId,
      keyName,
      tab,
      showMapView,
      selectedSiteIdForMapView,
      siteTypeQuery: filterType
    };

    try {
      if (editMode) {
        await BookmarkService.updateBookmarkData({
          bookmarkId: editMode,
          updatedData: siteBookmarkData
        });
        dispatch?.(bookmarksActions.setBookmarkValidity(true));
        ToasterUtil.showSuccess(`Bookmark updated successfully`);
      } else {
        await BookmarkService.addBookmarks(siteBookmarkData);
        ToasterUtil.showSuccess(`Bookmark saved`);
      }
      resetValue();
    } catch (error) {
      ToasterUtil.showError(`Failed to ${editMode ? 'update' : 'save'} bookmark`);
    }
  };

  const resetValue = () => {
    setOpen(false);
    setBookmarkName('');
    setPinToGlance(false);
  };

  return (
    <BookMarkModal
      editMode={editMode}
      open={open}
      setOpen={() => {
        resetValue();
      }}
      onSubmit={onSubmit}
      onDelete={onDelete}
      disabledBtn={_.isEmpty(bookmarkName)}
      statusText={'Name that bookmark.'}
      modalTextUpper={'Give your bookmark a short, descriptive name.'}
      modalTextLower={() => (
        <>
          <InputField
            placeholder={placeholder}
            limit={40}
            onChange={(e) => {
              const value = e?.target?.value;
              if (value.length === 0 || (value.length >= 1 && value[0] !== ' ')) {
                setBookmarkName(value);
              }
            }}
            value={bookmarkName}
            defaultValue={bookmarkName}
          />
          <p className="label-bold text-right text-grey-400 mt-1">{bookmarkName?.length || 0}/40</p>
        </>
      )}
      progressData={() => (
        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Checkbox
            text={'Pin to ‘At a glance’ on Home'}
            checked={pinToGlance}
            handleChange={(e) => setPinToGlance(e?.target?.checked)}
            textTransformNone
            labelClassName={style.siteBookmarkLabel}
            checkMarkAfter={style.siteBookmarkCheckbox}
          />
        </div>
      )}
      textBtn={'NEVERMIND'}
    />
  );
};

export default React.memo(SiteBookmark, _.isEqual);
